// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyBeLPVRftB6-zBYVN8rS9LSmkbb4DFoqAg",
  authDomain: "expoempleo-evento.firebaseapp.com",
  databaseURL: "https://expoempleo-evento.firebaseio.com",
  projectId: "expoempleo-evento",
  storageBucket: "expoempleo-evento.appspot.com",
  messagingSenderId: "595890386787",
  appId: "1:595890386787:web:e4af1e09ec61d0c4e34556",
  measurementId: "G-35YBMPQFLL"
}

// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/expoempleo-evento.appspot.com/o/'